import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button, Nav, Tab, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getCibilStatus } from '../services/api';
import { useAuth } from '../context/AuthContext';

// Admin Dashboard Component
const AdminDashboard = ({ cibilStats, loading }) => {
  return (
    <>
      <h3 className="mb-4">System Overview</h3>
      <Row>
        <Col md={4}>
          <Card className="mb-4 stats-card border-primary">
            <Card.Body>
              <Card.Title>Pending</Card.Title>
              <Card.Text className="display-4 text-warning">
                {loading ? '...' : cibilStats.pending_count}
              </Card.Text>
              <Card.Text>Leads pending CIBIL check</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-success">
            <Card.Body>
              <Card.Title>Processed</Card.Title>
              <Card.Text className="display-4 text-success">
                {loading ? '...' : cibilStats.processed_count}
              </Card.Text>
              <Card.Text>Leads processed successfully</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-danger">
            <Card.Body>
              <Card.Title>Failed</Card.Title>
              <Card.Text className="display-4 text-danger">
                {loading ? '...' : cibilStats.failed_count}
              </Card.Text>
              <Card.Text>Leads failed CIBIL check</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <h3 className="mb-4">Admin Actions</h3>
      <Row>
        <Col md={4}>
          <Card className="mb-4 h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>Upload Module</Card.Title>
              <Card.Text className="flex-grow-1">
                Upload lead data and monitor the deduplication and CIBIL enrichment process.
              </Card.Text>
              <Link to="/upload">
                <Button variant="primary" className="w-100">Manage Uploads</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>Campaign Module</Card.Title>
              <Card.Text className="flex-grow-1">
                Create and manage campaigns, apply filters, and download qualified leads.
              </Card.Text>
              <Link to="/campaigns">
                <Button variant="primary" className="w-100">Manage Campaigns</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>User Management</Card.Title>
              <Card.Text className="flex-grow-1">
                Create and manage users, assign roles, and control access permissions.
              </Card.Text>
              <Link to="/admin/users">
                <Button variant="primary" className="w-100">Manage Users</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

// Maker Dashboard Component
const MakerDashboard = ({ cibilStats, loading }) => {
  return (
    <>
      <Alert variant="info">
        <strong>Maker Dashboard</strong> - Upload and manage lead data
      </Alert>

      <h3 className="mb-4">Upload Statistics</h3>
      <Row>
        <Col md={4}>
          <Card className="mb-4 stats-card border-primary">
            <Card.Body>
              <Card.Title>Pending</Card.Title>
              <Card.Text className="display-4 text-warning">
                {loading ? '...' : cibilStats.pending_count}
              </Card.Text>
              <Card.Text>Leads pending CIBIL check</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-success">
            <Card.Body>
              <Card.Title>Processed</Card.Title>
              <Card.Text className="display-4 text-success">
                {loading ? '...' : cibilStats.processed_count}
              </Card.Text>
              <Card.Text>Leads processed successfully</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-danger">
            <Card.Body>
              <Card.Title>Failed</Card.Title>
              <Card.Text className="display-4 text-danger">
                {loading ? '...' : cibilStats.failed_count}
              </Card.Text>
              <Card.Text>Leads failed CIBIL check</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <h3 className="mb-4">Upload Actions</h3>
      <Row>
        <Col md={12}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Upload New Leads</Card.Title>
              <Card.Text>
                Upload raw lead data in CSV or Excel format. The system will check for required fields,
                perform deduplication, and queue valid leads for CIBIL API processing.
              </Card.Text>
              <Link to="/upload">
                <Button variant="primary" className="w-100">Upload Leads</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

// Cibil Uploader Dashboard
const CibilUploaderDashboard = ({ cibilStats, loading }) => {
  return (
    <>
      <Alert variant="info">
        <strong>Cibil Uploader Dashboard</strong> - Upload and manage cibil lead data
      </Alert>

      <h3 className="mb-4">Upload Statistics</h3>
      <Row>
        <Col md={4}>
          <Card className="mb-4 stats-card border-primary">
            <Card.Body>
              <Card.Title>Pending</Card.Title>
              <Card.Text className="display-4 text-warning">
                {loading ? '...' : cibilStats.pending_count}
              </Card.Text>
              <Card.Text>Leads pending CIBIL check</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-success">
            <Card.Body>
              <Card.Title>Processed</Card.Title>
              <Card.Text className="display-4 text-success">
                {loading ? '...' : cibilStats.processed_count}
              </Card.Text>
              <Card.Text>Leads processed successfully</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-danger">
            <Card.Body>
              <Card.Title>Failed</Card.Title>
              <Card.Text className="display-4 text-danger">
                {loading ? '...' : cibilStats.failed_count}
              </Card.Text>
              <Card.Text>Leads failed CIBIL check</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <h3 className="mb-4">Upload Actions</h3>
      <Row>
        <Col md={12}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Upload New Leads</Card.Title>
              <Card.Text>
                Upload raw lead data in CSV or Excel format. The system will check for required fields,
                perform deduplication, and queue valid leads for CIBIL API processing.
              </Card.Text>
              <Link to="/cibil-upload">
                <Button variant="primary" className="w-100">Upload Leads</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

// Campaign Manager Dashboard Component
const CampaignManagerDashboard = ({ cibilStats, loading }) => {
  return (
    <>
      <Alert variant="info">
        <strong>Campaign Manager Dashboard</strong> - Create and manage marketing campaigns
      </Alert>

      <h3 className="mb-4">Campaign Statistics</h3>
      <Row>
        <Col md={4}>
          <Card className="mb-4 stats-card border-primary">
            <Card.Body>
              <Card.Title>Available Leads</Card.Title>
              <Card.Text className="display-4 text-primary">
                {loading ? '...' : cibilStats.processed_count}
              </Card.Text>
              <Card.Text>Leads available for campaigning</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-success">
            <Card.Body>
              <Card.Title>Active Campaigns</Card.Title>
              <Card.Text className="display-4 text-success">
                {loading ? '...' : '0'}
              </Card.Text>
              <Card.Text>Currently active campaigns</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 stats-card border-secondary">
            <Card.Body>
              <Card.Title>Completed</Card.Title>
              <Card.Text className="display-4 text-secondary">
                {loading ? '...' : '0'}
              </Card.Text>
              <Card.Text>Completed campaigns</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <h3 className="mb-4">Campaign Actions</h3>
      <Row>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Create New Campaign</Card.Title>
              <Card.Text>
                Create a new marketing campaign by selecting a bank and process, defining target audience
                with filters on CIBIL data, and download leads for outreach.
              </Card.Text>
              <Link to="/campaigns">
                <Button variant="primary" className="w-100">Create Campaign</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Manage Campaigns</Card.Title>
              <Card.Text>
                View and manage all your campaigns, check lead counts, update filters,
                and download leads with journey URLs.
              </Card.Text>
              <Link to="/campaigns">
                <Button variant="primary" className="w-100">View Campaigns</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

const HomePage = () => {
  const [cibilStats, setCibilStats] = useState({
    pending_count: 0,
    processed_count: 0,
    failed_count: 0,
  });
  const [loading, setLoading] = useState(true);
  
  const { user, hasRole } = useAuth();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCibilStatus();
        setCibilStats(data);
      } catch (error) {
        console.error('Error fetching CIBIL stats:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);
  
  // Determine which dashboard to show based on user role
  const renderDashboard = () => {
    if (hasRole('admin')) {
      return <AdminDashboard cibilStats={cibilStats} loading={loading} />;
    } else if (hasRole('maker')) {
      return <MakerDashboard cibilStats={cibilStats} loading={loading} />;
    } else if (hasRole('campaign_manager')) {
      return <CampaignManagerDashboard cibilStats={cibilStats} loading={loading} />;
    } else if (hasRole('cibil_uploader')) {
      return <CibilUploaderDashboard cibilStats={cibilStats} loading={loading} />;
    } else {
      return <Alert variant="warning">No role assigned. Please contact an administrator.</Alert>;
    }
  };
  
  return (
    <div>
      <div className="jumbotron bg-light p-5 rounded mb-4">
        <h1 className="display-5">Welcome, {user?.username}!</h1>
        <p className="lead">
          Data Vault - CIBIL Screening & Campaigning System
        </p>
        <hr className="my-4" />
      </div>
      
      {renderDashboard()}
    </div>
  );
};

export default HomePage;